import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import SVGInline from 'react-svg-inline';

import styles from './Checkbox.scss';
import checkIcon from '../../Icon/check.svg';

export interface CheckboxProps extends WrappedFieldProps {
  id?: string;
  name?: string;
  label?: string;
}

const Checkbox: React.SFC<CheckboxProps> = ({ input, id, name, label }) => (
  <div className={styles.wrapper}>
    <input
      {...input}
      type="checkbox"
      className={styles.checkbox}
      name={name}
      id={id}
      checked={input.value}
    />
    <label htmlFor={id} className={styles.label}>
      <span className={styles.container}>
        <SVGInline svg={checkIcon} className={styles.icon} />
      </span>
      {label && <span className={styles.text}>{label}</span>}
    </label>
  </div>
);

export default (props: WrappedFieldProps) => <Checkbox {...props} />;



// WEBPACK FOOTER //
// /www/client/src/components/Input/Checkbox/Checkbox.tsx